import { handleRequest } from "./mockApi";

export const API = "/api";

const call = (method, path, params, body) =>
  Promise.resolve().then(() => handleRequest(method, path, params, body));

export const api = {
  get: (path, params) => call("GET", path, params),
  post: (path, body) => call("POST", path, undefined, body),
  put: (path, body) => call("PUT", path, undefined, body),
  del: (path) => call("DELETE", path),
};

export default api;